import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=492c20d2&scoped=true&"
import script from "./accept.vue?vue&type=script&lang=ts&"
export * from "./accept.vue?vue&type=script&lang=ts&"
import style0 from "./accept.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./accept.vue?vue&type=style&index=1&id=492c20d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c20d2",
  null
  
)

export default component.exports